import React, { useState } from 'react';
import { InputField } from '../../../../components/controls/InputField';
import ButtonControl from '../../../../components/controls/ButtonControl';
import '../../../../styles/rsuite_override.css';
import _ from 'lodash';
import { SelectListControl } from '../../../../components/controls';
import { TreePicker } from 'rsuite';
import $ from 'jquery';

export default function DistrictFilter({ org, districtMgr, onFilterChange, onClearFilter, hideFilter }) {

    const handleFilterChange = (value, fieldName) => {
        if (fieldName === "IsActive" && value === "true") {
            value = true
        } else if (fieldName === "IsActive" && value === "false") {
            value = false
        }

        if (onFilterChange) {
            onFilterChange(fieldName, value)
        }
    }

    const handleClearFilter = () => {
        if (onClearFilter) {
            onClearFilter();
        }

        $(".rs-picker-toggle-clean").trigger("click");
    }

    return (
        <>
            <div className="d-flex justify-content-center contentFilter">
                <div>
                    <div className="filterTitle">District Management</div>
                    <div className="filterControl">
                        <InputField
                            id='role'
                            title='Search'
                            value={districtMgr?.Filter?.search ?? ''}
                            fieldName='search'
                            disableError={true}
                            placeholder='District'
                            onChange={(value, fieldName) => handleFilterChange(value, fieldName)}>
                        </InputField>
                    </div>
                    <div className="filterControl">
                        {org && !hideFilter && <InputField
                            title="Organization"
                            fieldName="ClientId"
                            disableError={true}
                        >
                            <TreePicker
                                height={320}
                                width={400}
                                data={org ?? []}
                                valueKey={'OrgId'}
                                labelKey={'Name'}
                                onClean={() => handleFilterChange('', 'ClientId')}
                                onSelect={(a, val) => handleFilterChange(val, 'ClientId')}
                                placement="autoVerticalStart"
                            />
                        </InputField>}
                    </div>
                    <div className="filterControl">
                        <InputField id='IsActive'
                            title='Active?'
                            fieldName='IsActive'
                            value={districtMgr?.Filter?.IsActive ?? true}
                            disableError={true}
                            onChange={(value, fieldName) => handleFilterChange(value, fieldName)}>
                            <SelectListControl textValuePairs={[{ text: 'Yes', value: true }, { text: 'No', value: false }]} />
                        </InputField>
                    </div>
                    <div className="filterControl  btn-clear">
                        <ButtonControl
                            onClick={handleClearFilter}
                            type="cancel">
                            Clear
                        </ButtonControl>
                    </div>
                </div>
            </div >
        </>
    );
}